import React from "react";
import { useEffect } from "react";
import { apiURL } from "../../config";
import PromptForm from "./form";
import ChatWindow from "./chatWindow";
import { useSelector, useDispatch } from "react-redux";
import { messagesReplace, messagesClear } from "../../redux/messagesSlice";
import NavBar from "../navBar";
import { setSideBar } from "../../redux/sideBarSlice";
import { setMessagesStatus } from "../../redux/messagesStatusSlice";

function Chat() {
  const conversationId = useSelector((state) => state.conversationId);
  const modelPanel = useSelector((state) => state.modelPanel);
  const dispatch = useDispatch();

  useEffect(() => {
    //console.log('Chat effect')
    let ignore = false;
    const fetchConversation = async () => {
      try {
        console.log("Fetching conversation: ", conversationId);
        const res = await fetch(
          `${apiURL}/api/conversation/${conversationId}`,
          { credentials: "include" }
        );
        const data = await res.json();
        //console.log(data)
        if (!ignore) {
          if (data.messages.length > 1) {
            // ==1说明新对话正在接收第一个answer。此时不要replace。
            dispatch(setMessagesStatus("SUCCESS"));
            dispatch(messagesReplace(data.messages));
          } else {
            console.log("Only receive one message. Ignore.");
          }
          // if (data.template) {
          //   setSelectedTemplate(data.template);
          // }
        } else {
          console.log("Chat effect ignore");
        }
      } catch (error) {
        console.log("Error fetching conversation: ", error);
        dispatch(setMessagesStatus("ERROR"));
        dispatch(messagesClear());
      }
    };
    if (conversationId !== "NEW") {
      fetchConversation();
    } else {
      dispatch(messagesClear());
    }
    return () => {
      ignore = true;
    };
  }, [conversationId, dispatch]);

  return (
    <div
      className={`relative grow overflow-y-auto pt-14 bg-[rgb(45,45,42)]  ${
        modelPanel === "right" && "pr-[328px]"
      }`}
    >
      <NavBar />
      <div className="relative mt-4 px-6">
        <ChatWindow />
      </div>
      <SideBarArrow />
      <PromptForm />
    </div>
  );
}

const SideBarArrow = () => {
  const dispatch = useDispatch();
  return (
    <div
      className="fixed p-2 top-1/2 left-0 -translate-y-1/2 w-14 h-14 -translate-x-4 text-white scale-x-[40%] scale-y-[110%] opacity-[30%] hover:opacity-80 select-none cursor-pointer"
      onClick={() => {
        dispatch(setSideBar("float"));
      }}
    >
      {rightArrowSVG}
    </div>
  );
};

const rightArrowSVG = (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="opacity-90"
  >
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M10 7L15 12L10 17"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

export default Chat;
